import React, { FC } from 'react';

import useTimer from '@interlayer/js/custom/components/main/BingoScheduler/hooks/useTimer';

import { ListData } from '../types';

interface Props {
    style: Record<string, any>;
    drawTime: string;
    setShouldRemoveGame: (shouldRemove: boolean) => void;
    listData: ListData;
}

const BingoSchedulerTimer: FC<Props> = ({ style, drawTime, setShouldRemoveGame, listData }) => {
    const time = useTimer({ drawTime, setShouldRemoveGame, listData });

    return (
        <div className={style.bingo_scheduler__timer}>
            <span className={style.bingo_scheduler__times_svg} />

            <span className={style.bingo_scheduler__timer_value}>{time.renderedView}</span>
        </div>
    );
};

export default BingoSchedulerTimer;
